/* eslint-disable react-hooks/exhaustive-deps */

import { useContractWrite, useWaitForTransaction } from 'wagmi';

import config from '../../constants/baseConfig';
import useCaptureRpcException from '../useCaptureRpcException';
import { useEffect } from 'react';
import useSnackbarRpcError from '../useSnackbarRpcError';

const useApproveAny721ContractCall = (
  tokenAddress: string,
  spenderAddress?: string,
  onSuccess?: () => void
): [() => void, boolean | undefined] => {
  const [{ data, loading: isLoading, error: writeError }, approve] =
    useContractWrite(
      {
        addressOrName: tokenAddress,
        contractInterface: config.contracts.traitsContract.interface,
      },
      'setApprovalForAll',
      {
        args: [spenderAddress, true],
      }
    );

  const [{ data: waitData, loading: isWaiting, error: waitError }] =
    useWaitForTransaction({
      wait: data?.wait,
    });

  useSnackbarRpcError(writeError);
  useSnackbarRpcError(waitError);

  useCaptureRpcException(waitError);
  useCaptureRpcException(writeError);

  useEffect(() => {
    if (!isWaiting && waitData) {
      onSuccess?.();
    }
  }, [isWaiting, waitData]);

  return [approve, isLoading || isWaiting];
};

export default useApproveAny721ContractCall;
